// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"afa06b04","919":"a879db34","981":"13cdc04b"}[chunkId] + ".chunk.js";
};